// extracted by mini-css-extract-plugin
export default {"button-text":"ButtonText_button-text__eyCHV"};